import { InputStatus } from '../data/rsTypes';
import { t } from '.';

export const stringValidator = (nameInputValue: string) => {
	const validationResult = {
		isValid: true,
		errorMessage: null,
	};

	if (!nameInputValue) {
		validationResult.errorMessage = t('fieldRequired');
		validationResult.isValid = false;
	}
	return validationResult;
};

export const emailValidator = (emailInputValue: string) => {
	const validationResult = {
		isValid: true,
		errorMessage: null,
	};

	if (!emailInputValue) {
		validationResult.isValid = false;
		validationResult.errorMessage = t('fieldRequired');
	} else {
		const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
		if (!emailRegex.test(emailInputValue)) {
			validationResult.isValid = false;
			validationResult.errorMessage = t('invalidEmail');
		}
	}
	return validationResult;
};

export function validatePasscode(value) {
	let status: InputStatus = 'success';
	let message = '';

	if (isNaN(value)) {
		status = 'error';
		message = t('SendSignatureRequest.securityOptions.passcodeOnlyDigits');
	} else if (value.length !== 5) {
		status = 'error';
		message = t('SendSignatureRequest.securityOptions.passcodeLengthError');
	}

	return { status, message };
}
